<template>
  <app-loader v-if="loggedInWithoutUserInfo" />
  <template v-else>
    <component :is="layout" :isHealth="false">
      <router-view />
    </component>
    <notifications :position="position" />
  </template>
</template>

<script>
import EmptyLayout from '@/layouts/EmptyLayout'
import StaffAuthLayout from '@/layouts/StaffAuthLayout'
import MainLayout from '@/layouts/MainLayout'
import AppLoader from '@/components/common/AppLoader'

export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    },
    position() {
      return window.innerWidth < 900 ? 'top' : 'bottom center'
    },
    loggedInWithoutUserInfo() {
      return this.$store.getters.GET_LOGGED_IN && !this.$store.getters.GET_CURRENT_USER_UUID
    },
  },
  components: {
    EmptyLayout,
    StaffAuthLayout,
    MainLayout,
    AppLoader,
  },
  created() {
    this.$store.commit('SET_AGENT', 'sa')
  },
  mounted() {
    if (this.loggedInWithoutUserInfo) {
      this.$store.dispatch('SET_CURRENT_USER')
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/main.scss';

.vue-notification-group {
  width: 440px !important;
  border-radius: 50px !important;
  left: calc(50% - 220px) !important;

  @media only screen and (max-width: $tablet-size) {
    width: 100% !important;
    margin-top: 24px;
    left: inherit !important;
  }
}

.vue-notification-template {
  background: rgba(21, 46, 57, 0.88) !important;
  border: none !important;
  border-radius: 50px !important;
}

.notification-content {
  font-size: 15px !important;
  text-align: center !important;
  line-height: 22px;
}

.vue-notification {
  // background: rgba(21, 46, 57, 0.88) !important;
  // border-radius: 50px !important;
  // font-size: 15px !important;
  // line-height: 22px !important;
  // color: #ffffff !important;
  // width: 400px !important;
  // style for title line
  .notification-title {
    /*...*/
  }

  // style for content
  .notification-content {
    /*...*/
  }
}
</style>
